"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var getColor = function getColor(color, themeColor) {
  return {
    primary: themeColor.brandPrimary.light,
    'primary-dark': themeColor.brandPrimary.medium,
    secondary: themeColor.brandSecondary.medium,
    text: themeColor.neutral['02'],
    'text-light': themeColor.neutral['03'],
    white: themeColor.neutral['08'],
    warning: themeColor.feedback.alert,
    error: themeColor.feedback.error,
    success: themeColor.feedback.success
  }[color];
};

var Text = _styledComponents["default"].p.withConfig({
  displayName: "Textstyle__Text",
  componentId: "sc-1tz630v-0"
})(function (_ref) {
  var theme = _ref.theme,
      align = _ref.align,
      color = _ref.color,
      display = _ref.display,
      margin = _ref.margin,
      variant = _ref.variant;
  return _extends({
    textAlign: align,
    display: display,
    color: getColor(color, theme.color),
    marginTop: 0,
    marginBottom: !margin && 0
  }, (0, _utils.getTextStyle)({
    theme: theme,
    variant: variant,
    margin: margin
  }), {
    svg: {
      fill: 'currentColor',
      width: '1em',
      height: '1em',
      top: '.125em',
      position: 'relative'
    }
  });
});

exports.Text = Text;